/**
 *  HomePage actions
 */

import {
  LOAD_USERS,
  LOAD_USERS_SUCCESS,
  LOAD_USERS_FAILURE,
  AGREE_TO_TERMS,
  AGREE_TO_TERMS_SUCCESS,
  AGREE_TO_TERMS_FAILURE,
  DECLINE_TERMS,
  DECLINE_TERMS_SUCCESS,
  DECLINE_TERMS_FAILURE,
  MANAGE_HISTORY,
  CHANGE_AGREE_BUTTON_STATE,
  LOAD_CSRF_TOKEN,
  LOAD_CSRF_TOKEN_SUCCESS,
  LOAD_CSRF_TOKEN_FAILURE
} from './constants';

/**
 * Initiate loading users
 * @param {string} token        A string containing the DAVA token
 *
 * @return {object}             An action object with a type of LOAD_USERS
 *                              passing the token variable
 */
export function usersLoadRequest(token) {
  return {
    type: LOAD_USERS,
    token,
  };
}

export function usersLoadSuccess(users) {
  return {
    type: LOAD_USERS_SUCCESS,
    users,
  };
}

export function usersLoadFailure(err) {
  return {
    type: LOAD_USERS_FAILURE,
    err,
  };
}

export function loadCSRFToken() {
  return {
    type: LOAD_CSRF_TOKEN,
  };
}

export function loadCSRFTokenSuccess(csrfToken) {
  return {
    type: LOAD_CSRF_TOKEN_SUCCESS,
    csrfToken,
  };
}

export function loadCSRFTokenFailure(error) {
  return {
    type: LOAD_CSRF_TOKEN_FAILURE,
    error,
  };
}

export function agreeToTermsRequest() {
  return {
    type: AGREE_TO_TERMS,
  };
}

export function agreeToTermsSuccess(terms, token, acceptTerms) {
  return {
    type: AGREE_TO_TERMS_SUCCESS,
    terms,
    token,
    acceptTerms,
  };
}

export function agreeToTermsFailure(err) {
  return {
    type: AGREE_TO_TERMS_FAILURE,
    err,
  };
}

export function declineTermsRequest() {
  return {
    type: DECLINE_TERMS,
  };
}

export function declineTermsSuccess(terms, token, acceptTerms) {
  return {
    type: DECLINE_TERMS_SUCCESS,
    terms,
    token,
    acceptTerms
  };
}

export function declineTermsFailure(err) {
  return {
    type: DECLINE_TERMS_FAILURE,
    err,
  };
}


export function manageHistory(location) {
  return {
    type: MANAGE_HISTORY,
    location,
  };
}

export function toggleAgreeButton(isVisible) {
  return {
    type: CHANGE_AGREE_BUTTON_STATE,
    isVisible,
  };
}
